import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function EventTreeEndStateIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect id="Rectangle" transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) " x="3.52941176" y="3.52941176" width="16.9411765" height="16.9411765" />
    </SvgIcon>
  );
}

export default EventTreeEndStateIcon;
